export const isCheckInIntake = (requestSource: string): boolean => {
  return requestSource === "CHECK_IN_INTAKE"
}
